import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import TextButton from '@spothero/ui/text-button';
import Link from 'common/router/Link';
import MultiRateChooser from './MultiRateChooser';

class PriceAndTermsMobile extends PureComponent {
    _onRateDetailsClick = () => {
        this.props.onRateDetailsClick('intro-rate');
    }

    render() {
        const {
            className,
            isMonthly,
            spot: {
                monthly_rates: monthlyRates,
                hourly_rates: hourlyRates,
                selectedRate,
                hasOversizedFee,
                vehicleRestriction
            },
            onMultiRateChange,
            onRateDetailsClick,
            onOnlineCommuterRateClick,
            onVehicleRestrictionsClick,
            checkoutUrl
        } = this.props;
        const classes = classNames(
            'PriceAndTerms',
            className
        );
        const availableRates = (isMonthly) ? monthlyRates : hourlyRates;
        const restrictionMessage = (hasOversizedFee && vehicleRestriction)
            ? 'Vehicle restrictions and fees.'
            : (hasOversizedFee)
                ? 'Oversized fee charged on site.'
                : (vehicleRestriction)
                    ? 'Vehicle restrictions apply.'
                    : null;

        return (
            <div className={classes}>
                {availableRates.length > 1 &&
                    <MultiRateChooser
                        selectedRate={selectedRate}
                        rates={availableRates}
                        onMultiRateChange={onMultiRateChange}
                        onInfoButtonClick={onRateDetailsClick}
                    />
                }
                {availableRates.length === 1 &&
                    <h4 className="PriceAndTerms-total-price">
                        <Link to={checkoutUrl}>
                            <span dangerouslySetInnerHTML={{__html: selectedRate.price_formatted}} /> Total
                        </Link>
                    </h4>
                }
                {isMonthly && selectedRate.introductory && selectedRate.introductory.rate &&
                    <small className="intro-rate">
                        Intro Rate.&nbsp;
                        <TextButton
                            data-section="intro-rate"
                            onClick={this._onRateDetailsClick}
                        >
                            Details
                        </TextButton>
                    </small>
                }
                {!isMonthly &&
                    <span>
                        {selectedRate.online_commuter_rate &&
                            <small className="online-commuter-rate">
                                Online Special.&nbsp;
                                <TextButton
                                    onClick={onOnlineCommuterRateClick}
                                >
                                    Details
                                </TextButton>
                            </small>
                        }
                        {restrictionMessage &&
                            <small className="oversize-fee">
                                {restrictionMessage}&nbsp;
                                <TextButton
                                    onClick={onVehicleRestrictionsClick}
                                >
                                    Details
                                </TextButton>
                            </small>
                        }
                    </span>
                }
            </div>
        );
    }
}

PriceAndTermsMobile.propTypes = {
    className: PropTypes.string,
    isMonthly: PropTypes.bool,
    spot: PropTypes.object,
    onMultiRateChange: PropTypes.func,
    onRateDetailsClick: PropTypes.func,
    onOnlineCommuterRateClick: PropTypes.func,
    onVehicleRestrictionsClick: PropTypes.func,
    checkoutUrl: PropTypes.string
};

export default PriceAndTermsMobile;
